// eslint-disable-next-line no-use-before-define
import React, { Component } from 'react';
import { PageStatus } from '../../enums';
import { AuthAPI } from '../../API'
import Language from "../../Languages/Login/content.json";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { authRegistration } from "./auth.actions";
import { Assets } from 'enums';
import { checkStrongPassword } from "../../Helper/Validations";
import { changePasswordDict } from 'Languages/ContactsTranslations';
import PropTypes from 'prop-types';

class ResetPasswordForm extends Component {
    constructor(props) {
        super(props);
        (this.state = {
            error: null,
            status: PageStatus.None,
            input: { "password": null, "confirm_password": null },
            errors: {},
            token: null,
            passwordactive: false,
            passwordconfirmactive: false,
            metaData: null,
            pageContent: this.props.language === 'hi' ? Language.SignupHindi : Language.SignupEnglish,
            isPasswordVisible: false,
            isRepeatPasswordVisible: false,
            isValidPassword: true,
            notValidPasswordText: "",
            isValidConfirmPassword: true,
            notValidConfirmPasswordText: "",
            isPasswordMatched: false,
        });
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const token = this.props.match.params.token
        this.setState({ token: token })
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState(prevState => {
            const input = { ...prevState.input, [name]: value, };
            return { input, isPasswordMatched: input["confirm_password"] === input["password"], };
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        if (!input["password"]) {
            isValid = false;
            errors["password"] = "Please enter your password.";
        }
        if (!input["confirm_password"]) {
            isValid = false;
            errors["confirm_password"] = "Please enter your confirm password.";
        }

        if (typeof input["password"] !== "undefined" && typeof input["confirm_password"] !== "undefined") {
            if (input["password"] !== input["confirm_password"]) {
                isValid = false;
                errors["password"] = "Passwords don't match.";
            }
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    isPasswordStrong(ele, type) {
        let errors = {};
        errors["confirm_password"] = "";
        errors["password"] = "";
        this.setState({ errors: errors });
        if (ele.target.value === "") {
            const updatedState = {
                [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: true,
                [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: "",
                isButtonDisabled: false
            };
            this.setState(updatedState);
            return;
        }
        let passwordChecks = checkStrongPassword(ele);
        let isHindiTrue = this.props.language === 'hi';
        const getLabel = () => {
            if (type === 'password') { return isHindiTrue ? "पासवर्ड" : "Password"; }
            return isHindiTrue ? "कन्फर्म पासवर्ड" : "Confirm password";
        };
        const errorMessages = [
            {
                condition: passwordChecks.capitalLatterCheck,
                message: isHindiTrue ? " में एक बड़ा अक्षर होना चाहिए" : " should contain one capital letter"
            },
            {
                condition: passwordChecks.smallLatterCheck,
                message: isHindiTrue ? " में एक छोटा अक्षर होना चाहिए" : " should contain one small letter"
            },
            {
                condition: passwordChecks.numericValCheck,
                message: isHindiTrue ? " में एक संख्यात्मक मान होना चाहिए" : " should contain one numeric value"
            },
            {
                condition: passwordChecks.specialCharCheck,
                message: isHindiTrue ? " में एक विशेष प्रतीक होना चाहिए" : " should contain one special character"
            },
            {
                condition: passwordChecks.lengthCheck,
                message: isHindiTrue ? " की लंबाई कम से कम 8 अक्षर की होनी चाहिए" : " length should be atleast of 8 character"
            },
        ];
        const firstFailed = errorMessages.find(error => !error.condition);
        const isAllValid = errorMessages.every(error => error.condition);
        const label = getLabel();
        const stateUpdate = {
            [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: isAllValid,
            [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: isAllValid ? "" : label + firstFailed.message,
            isButtonDisabled: !isAllValid
        };
        this.setState(stateUpdate);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.validate()) {
            return Promise.resolve()
                .then(() => this.setState({ status: PageStatus.Submitting }))
                .then(() => AuthAPI.UpdateNewPassword(this.state.token, this.state.input.password))
                .then((res) => {
                    if (res === 'Not found.') {
                        alert('Invalid Token');
                        this.setState({ status: PageStatus.Submitted })
                    }
                    alert('password updated  successfully ');
                    this.setState({ status: PageStatus.Submitted }, () => {
                        let input = {};
                        input["password"] = "";
                        input["confirm_password"] = "";
                        this.setState({ input: input });
                        this.props.history.push({
                            pathname: '/auth/login'
                        })
                    })
                })
                .catch((error) => {
                    this.setState({ status: PageStatus.Error, error: error.message });
                });
        }
    }

    render() {
        const conditionalVarObj = {
            true: {
                "inputPwIcon": "fa fa-eye-slash", // used
                "inputPwType": "text", // used
                "respoMsg": "18px", // used
                "password": "पासवर्ड", // used
                "confirmPassword": "पासवर्ड की पुष्टि कीजिये", // used
                "checkBoxSize": "18px",
                "resetPassword": "पासवर्ड रीसेट", // used
            },
            false: {
                "inputPwIcon": "fa fa-eye",
                "inputPwType": "password",
                "respoMsg": "16px",
                "password": "Password",
                "confirmPassword": "Confirm password",
                "checkBoxSize": "12px",
                "resetPassword": "Reset Password",
            },
        };
        const lang = this.props.language ?? 'en';
        const { isPasswordMatched, isValidPassword, notValidPasswordText, isValidConfirmPassword, notValidConfirmPasswordText, } = this.state;
        return (
            <div>
                <section className='register_page'>
                    <div className='register_left'>
                        <img
                            src={Assets.Logo2}
                            alt='register-left'
                            className='img-fluid '
                            height={50}
                        />
                    </div>
                    <div className='register_right'>
                        <h2 className='register_heading'> {conditionalVarObj[this.props.language === 'hi']["resetPassword"]}</h2>

                        <div className='or_border'>
                            <p className='or_text'></p>
                        </div>
                        <form onSubmit={this.handleSubmit} >
                            <div className='mb-3 mt-3' style={{ position: 'relative', }}>
                                <input
                                    type={conditionalVarObj[this.state.isPasswordVisible]["inputPwType"]}
                                    name="password"
                                    value={this.state.input.password}
                                    onChange={this.handleChange}
                                    onInput={(e) => this.isPasswordStrong(e, 'password')}
                                    className='form-control'
                                    placeholder={conditionalVarObj[this.props.language === 'hi']["password"]}
                                    onClick={() => this.setState((prev) => { return { passwordactive: !prev.passwordactive } })} />
                                <button
                                    type="button"
                                    style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                                    onClick={() => this.setState((prev) => { return { isPasswordVisible: !prev.isPasswordVisible } })}
                                    className={this.state.input?.password?.length > 0 ? "bg-transparent" : "d-none"}
                                >
                                    <i className={conditionalVarObj[!this.state.isPasswordVisible]["inputPwIcon"]}></i>
                                </button>
                            </div>
                            {isValidPassword ? "" :
                                <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                                    {notValidPasswordText}
                                </div>
                            }
                            <div className='mb-3 mt-3' style={{ position: 'relative', }}>
                                <input
                                    type={conditionalVarObj[this.state.isRepeatPasswordVisible]["inputPwType"]}
                                    name="confirm_password"
                                    value={this.state.input.confirm_password}
                                    onChange={this.handleChange}
                                    onInput={(e) => this.isPasswordStrong(e, 'confirmpassword')}
                                    className='form-control'
                                    placeholder={conditionalVarObj[this.props.language === 'hi']["confirmPassword"]}
                                    onClick={() => this.setState((prev) => { return { passwordconfirmactive: !prev.passwordconfirmactive } })}
                                />
                                <button
                                    type="button"
                                    style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                                    onClick={() => this.setState((prev) => { return { isRepeatPasswordVisible: !prev.isRepeatPasswordVisible } })}
                                    className={this.state.input?.confirm_password?.length > 0 ? "bg-transparent" : "d-none"}
                                >
                                    <i className={conditionalVarObj[!this.state.isRepeatPasswordVisible]["inputPwIcon"]}></i>
                                </button>
                            </div>
                            {isPasswordMatched && this.state.input.password && this.state.input.confirm_password && isValidPassword && isValidConfirmPassword ?
                                <div className="alert alert-success">{changePasswordDict[lang]["Passwords Matched"] || "Passwords matched!"}</div> : ""
                            }
                            {!isPasswordMatched && this.state.input.password && this.state.input.confirm_password && isValidPassword && isValidConfirmPassword ?
                                <div className="alert alert-danger">{changePasswordDict[lang]["Not Matched"] || "Not Matched"}</div> : ""}
                            {isValidConfirmPassword ? "" :
                                <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                                    {notValidConfirmPasswordText}
                                </div>}
                            <div className="text-danger">{this.state.errors.password}</div>
                            <div className="text-danger">{this.state.errors.confirm_password}</div>

                            <button type="submit" className='create_acc_btn rippleeffect-btn' disabled={!isPasswordMatched || !isValidPassword || !isValidConfirmPassword} >
                                {this.props.language === 'hi' ? 'जमा करना' : 'Submit'}
                            </button>

                        </form>
                    </div>
                </section>
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        isAuth: state.adminUser.adminUser.isAuthenticated,
        token: state.adminUser.adminUser.token,
        language: state.adminUser.adminUser.language,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
    };
};

const ResetPasswordFormWithState = withRouter(connect(
    mapStateToProps, { authRegistration },
)(ResetPasswordForm));

ResetPasswordForm.propTypes = {
    language: PropTypes.string,
    match: PropTypes.shape({
        params: PropTypes.shape({
            token: PropTypes.string,
        }),
    }),
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
};

export {
    ResetPasswordForm,
    ResetPasswordFormWithState,
};
